<script setup>
import { FormKit, FormKitMessages } from '@formkit/vue'

const { $auth } = useNuxtApp()
const $route = useRoute()

const emailVerify = ref(null)
const isLoading = ref(false)
const formErrors = ref([
  'Don’t see the email? Check your spam folder or request a new one.',
])
const theme = ref(
  Object.assign(
    {
      emailVerify: {
        submitButton: {
          classes: '',
          label: 'Resend Verification',
        },
      },
    },
    $auth.authModalTheme,
  ),
)
const verificationEmail = computed(
  () => $auth.authEmail || 'your email address',
)

async function resendEmailVerification() {
  if (!$auth.authEmail) {
    formErrors.value = [
      'Missing email address. Please return and try logging in again.',
    ]
    return
  }
  isLoading.value = true
  try {
    const nextPath = $auth.authRedirect || $route.fullPath
    await $auth.resendEmailConfirmationEmail({
      email: $auth.authEmail,
      next: nextPath,
    })
    formErrors.value = [
      `Verification email sent to ${verificationEmail.value}.`,
      'Don’t see the email? Check your spam folder or request a new one.',
    ]
  } catch (e) {
    const apiError = e?.data?.error || e?.errors?.non_field_errors?.[0]
    formErrors.value = [
      apiError || 'Unable to resend verification email. Please try again.',
    ]
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  emailVerify.value.$el.querySelector('button').focus()
  // TODO: check if email already validated?
})
</script>

<template>
  <FormKit
    ref="emailVerify"
    type="form"
    :actions="false"
    name="verify_email"
    :errors="formErrors"
    @submit="resendEmailVerification"
  >
    <slot name="title">
      <h4>Verify Your Email</h4>
    </slot>
    <p>
      Please verify <b>{{ verificationEmail }}</b> to continue logging in.<br />This
      helps us keep Wine Access secure.
    </p>
    <p>We sent a verification email with a link to confirm your account.</p>
    <FormKitMessages class="centered-login-error" />
    <FormKit
      type="submit"
      :disabled="isLoading"
      :label="isLoading ? 'Sending...' : theme.emailVerify.submitButton.label"
      :input-class="theme.emailVerify.submitButton.classes"
    />
  </FormKit>
</template>
